// "use client";

// import { Box, Typography, useTheme, alpha } from "@mui/material";
// import { useEffect, useState, useRef } from "react";
// import IndustryCard from "./IndustryCard";
// import { industries } from "@/constant";
// // import { shades } from "@/styles/theme";

// const IndustryCarousel = () => {
//   const theme = useTheme();
//   const carouselRef = useRef<HTMLDivElement>(null);
//   const [isPaused, setIsPaused] = useState(false);

//   // Duplicate industries for seamless loop
//   const duplicatedIndustries = [...industries, ...industries, ...industries];

//   useEffect(() => {
//     const carousel = carouselRef.current;
//     if (!carousel) return;

//     let animationFrameId: number;
//     let position = 0;
//     const speed = 0.5; // Adjust speed here (pixels per frame)

//     const animate = () => {
//       if (!isPaused && carousel) {
//         position -= speed;

//         // Reset position when we've scrolled through one set of industries
//         if (position <= -carousel.scrollWidth / 3) {
//           position = 0;
//         }

//         carousel.style.transform = `translateX(${position}px)`;
//       }
//       animationFrameId = requestAnimationFrame(animate);
//     };

//     animationFrameId = requestAnimationFrame(animate);

//     return () => {
//       cancelAnimationFrame(animationFrameId);
//     };
//   }, [isPaused]);

//   return (
//     <Box
//       sx={{
//         py: 8,
//         background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 1)} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Header */}
//       <Typography
//         variant="h2"
//         textAlign="center"
//         mb={4}
//         sx={{
//           fontWeight: 700,
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
//           backgroundClip: "text",
//           WebkitBackgroundClip: "text",
//           color: "transparent",
//           fontSize: { xs: "2.5rem", md: "3rem" },
//         }}
//       >
//         Industries We Serve
//       </Typography>

//       {/* Gradient Overlays */}
//       <Box
//         sx={{
//           position: "absolute",
//           left: 0,
//           top: 0,
//           bottom: 0,
//           width: "100px",
//           background: `linear-gradient(90deg, ${alpha(theme.palette.background.paper, 1)} 0%, ${alpha(theme.palette.background.paper, 0)} 100%)`,
//           zIndex: 2,
//         }}
//       />
//       <Box
//         sx={{
//           position: "absolute",
//           right: 0,
//           top: 0,
//           bottom: 0,
//           width: "100px",
//           background: `linear-gradient(90deg, ${alpha(theme.palette.background.paper, 0)} 0%, ${alpha(theme.palette.background.paper, 1)} 100%)`,
//           zIndex: 2,
//         }}
//       />

//       {/* Carousel Container */}
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           overflow: "hidden",
//           py: 2,
//         }}
//         onMouseEnter={() => setIsPaused(true)}
//         onMouseLeave={() => setIsPaused(false)}
//       >
//         {/* Carousel Track */}
//         <Box
//           ref={carouselRef}
//           sx={{
//             display: "flex",
//             gap: { xs: 2, md: 3 },
//             willChange: "transform",
//             transition: "transform 0.1s linear",
//           }}
//         >
//           {duplicatedIndustries.map((industry, index) => (
//             <Box
//               key={`${industry.name}-${index}`}
//               sx={{
//                 flex: "0 0 auto",
//                 width: {
//                   xs: "calc(50% - 8px)",
//                   sm: "calc(33.333% - 11px)",
//                   md: "calc(25% - 12px)",
//                   lg: "calc(20% - 12px)",
//                   xl: "calc(16.666% - 12px)",
//                 },
//                 minWidth: {
//                   xs: "calc(50% - 8px)",
//                   sm: "calc(33.333% - 11px)",
//                   md: "calc(25% - 12px)",
//                   lg: "calc(20% - 12px)",
//                   xl: "calc(16.666% - 12px)",
//                 },
//               }}
//             >
//               <IndustryCard industry={industry} />
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       {/* Progress Indicator */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           mt: 4,
//           gap: 1,
//         }}
//       >
//         {industries.map((_, index) => (
//           <Box
//             key={index}
//             sx={{
//               width: 8,
//               height: 8,
//               borderRadius: "50%",
//               backgroundColor: isPaused
//                 ? alpha(theme.palette.primary.main, 0.3)
//                 : alpha(theme.palette.primary.main, 0.1),
//               transition: "background-color 0.3s ease",
//               "&:nth-of-type(1)": {
//                 backgroundColor: isPaused
//                   ? theme.palette.primary.main
//                   : alpha(theme.palette.primary.main, 0.6),
//               },
//             }}
//           />
//         ))}
//       </Box>

//       {/* Instructions */}
//       <Typography
//         variant="caption"
//         textAlign="center"
//         display="block"
//         mt={2}
//         color="text.secondary"
//       >
//         Hover to pause • Scrolls automatically
//       </Typography>
//     </Box>
//   );
// };

// export default IndustryCarousel;
"use client";

import { Box, Typography, useTheme, alpha } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import IndustryCard from "./IndustryCard";
import { industries } from "@/constant";
// import { shades } from "@/styles/theme";

const IndustryCarousel = () => {
  const theme = useTheme();
  const carouselRef = useRef<HTMLDivElement>(null);
  const positionRef = useRef(0); // Use ref to persist position
  const [isPaused, setIsPaused] = useState(false);

  // Duplicate industries for seamless loop
  const duplicatedIndustries = [...industries, ...industries, ...industries];

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    let animationFrameId: number;
    const speed = 0.5;

    const animate = () => {
      if (!isPaused && carousel) {
        positionRef.current -= speed;

        // Reset position when we've scrolled through one set of industries
        if (positionRef.current <= -carousel.scrollWidth / 3) {
          positionRef.current = 0;
        }

        carousel.style.transform = `translateX(${positionRef.current}px)`;
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isPaused]);

  return (
    <Box
      sx={{
        py: 8,
        background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 1)} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Gradient Overlays */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "100px",
          background: `linear-gradient(90deg, ${alpha(theme.palette.background.paper, 1)} 0%, ${alpha(theme.palette.background.paper, 0)} 100%)`,
          zIndex: 2,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "100px",
          background: `linear-gradient(90deg, ${alpha(theme.palette.background.paper, 0)} 0%, ${alpha(theme.palette.background.paper, 1)} 100%)`,
          zIndex: 2,
        }}
      />

      {/* Carousel Container */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
          py: 2,
        }}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Carousel Track */}
        <Box
          ref={carouselRef}
          sx={{
            display: "flex",
            gap: { xs: 2, md: 3 },
            willChange: "transform",
          }}
        >
          {duplicatedIndustries.map((industry, index) => (
            <Box
              key={`${industry.name}-${index}`}
              sx={{
                flex: "0 0 auto",
                width: {
                  xs: "calc(50% - 8px)",
                  sm: "calc(33.333% - 11px)",
                  md: "calc(25% - 12px)",
                  lg: "calc(20% - 12px)",
                  xl: "calc(16.666% - 12px)",
                },
                minWidth: {
                  xs: "calc(50% - 8px)",
                  sm: "calc(33.333% - 11px)",
                  md: "calc(25% - 12px)",
                  lg: "calc(20% - 12px)",
                  xl: "calc(16.666% - 12px)",
                },
              }}
            >
              <IndustryCard industry={industry} />
            </Box>
          ))}
        </Box>
      </Box>

      {/* Progress Indicator */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 4,
          gap: 1,
        }}
      >
        {industries.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: isPaused
                ? alpha(theme.palette.primary.main, 0.3)
                : alpha(theme.palette.primary.main, 0.1),
              transition: "background-color 0.3s ease",
              "&:nth-of-type(1)": {
                backgroundColor: isPaused
                  ? theme.palette.primary.main
                  : alpha(theme.palette.primary.main, 0.6),
              },
            }}
          />
        ))}
      </Box>

      {/* Instructions */}
      <Typography
        variant="caption"
        textAlign="center"
        display="block"
        mt={2}
        color="text.secondary"
      >
        Hover to pause • Scrolls automatically
      </Typography>
    </Box>
  );
};

export default IndustryCarousel;
